/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2024 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class claimhealthcaredelivery extends IceEntity {
  claim_healthcare_delivery_key: string = "";
  quantity_qualifier: string = "";
  quantity: number = 0.0;
  basis_for_measurement_code: string = "";
  frequency_unit_code: string = "";
  frequency_count: number = 0;
  number_of_periods: number = 0;
  time_period_qualifier: string = "";
  calendar_pattern_code: string = "";
  calendar_pattern_time_code: string = "";
  sample_selection_modulus: number = 0;
  record_version: number = 0;
  offline_record_status: number = 0;

  constructor() {
    super();
  }

  gettablename(): string {
  return "CLAIM_HEALTHCARE_DELIVERY";
  }
}


